import { camelCaseKeys } from '../apiTransformers/transformers';
/**
 * CamelCaseResponse decorator - transrofms keys in your Response to camelCase
 * @param function
 * @returns function
 ```
  import { CamelCaseResponse } from '../../_decorators';

  @CamelCaseResponse
  getVehicleSummary(vehicleVin: string): Promise<Component[]> {

  ```
 */
export function CamelCaseResponse(target, propertyName, propertyDescriptor) {
    const method = propertyDescriptor.value;
    propertyDescriptor.value = (...args) => {
        return (method.apply(target, args) || {}).then((response) => response
            ? camelCaseKeys(response, propertyName)
            : response);
    };
    return propertyDescriptor;
}
